import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { assignRowKeys } from './utils/row-key'
import { buildOrderLookupParams } from './utils/order-params'

Vue.use(Vuex)

const defaultTheme = {
    name: 'custom',
    textColor: '#fbff1f',
    backgroundColor: '#5b2a54',
    changeBtnColor: '#5bd0d2',
    sendBtnColor: '#5547bd',
    cancelBtnColor: '#bf5d1d',
    inputBackgroundColor: '#4d1949',
    selectBorderColor: '#22f793',
    inputTextColor: '#eae553',
    btnTextColor: '#000000',
};

export default new Vuex.Store({

    state: {
        preferences:{},
        all: {},
        email_address: null,
        order_number: null,
        selectedProducts: [],
        iban: null,
        fullName: null,
        phoneNumber: null,
        address1: null,
        address2: null,
        city: null,
        county: null,
        zipCode: null,
        country: null,
        bankAccountHolder: null,
        returnType: null,
        description: null,
        returnProducts: [],
        shop: null,
        token: null,
        allProducts: [],
        allProductsLoading: false,
        extensionVisible: true,
        themeJson: { ...defaultTheme }
    },
    getters: {
        order: state => {
            return state.all
        },
        preferences: state => {
            return state.preferences
        },
        selectedProducts: state => {
            return state.selectedProducts
        },
        email_address: state => {
            return state.email_address
        },
        phone_number: state => {
            return state.phoneNumber
        },
        order_number: state => {
            return state.order_number
        },
        iban: state => {
            return state.iban
        },
        bankAccountHolder: state => {
            return state.bankAccountHolder
        },
        returnType: state => {
            return state.returnType
        },
        description: state => {
            return state.description
        },
        returnProducts: state => {
            return state.returnProducts
        },
        allProducts: state => {
            return state.allProducts
        },
        allProductsLoading: state => {
            return state.allProductsLoading
        }

    },
    mutations: {
        setAll(state, items) {
            if (items && Array.isArray(items.products)) assignRowKeys(items.products)
            state.all = items
        },
        setEmail(state, value) {
            state.email_address = value
        },
        setOrderNumber(state, value) {
            state.order_number = value
        },
        setSelectedProducts(state, value) {
            state.selectedProducts = value
        },
        setIban(state, value) {
            state.iban = value
        },
        setFullName(state, value) {
            state.fullName = value
        },
        setPhoneNumber(state, value) {
            state.phoneNumber = value
        },
        setAddress1(state, value) {
            state.address1 = value
        },
        setAddress2(state, value) {
            state.address2 = value
        },
        setCity(state, value) {
            state.city = value
        },
        setCounty(state, value) {
            state.county = value
        },
        setZipCode(state, value) {
            state.zipCode = value
        },
        setCountry(state, value) {
            state.country = value
        },
        setBankAccountHolder(state, value) {
            state.bankAccountHolder = value
        },
        setReturnType(state, value) {
            state.returnType = value
        },
        setShop(state, value) {
            state.shop = value
        },
        setToken(state, value) {
            state.token = value
        },
        setDescription(state, value) {
            state.description = value
        },
        setReturnProducts(state, value) {
            state.returnProducts = value;
        },
        setShopPreferences(state, value) {
            state.preferences = value;
        },
        setExtensionVisible(state, visible) {
            state.extensionVisible = visible;
        },
        setAllProducts(state, value) {
            state.allProducts = Object.entries(
                value.reduce((acc, {productId, variantId, name, variant, sku, price, currency, image}) => {
                    // Group initialization
                    if (!acc[name]) {
                        acc[name] = {
                            'image': image,
                            'variants': []
                        };
                    }

                    // Grouping
                    // FIX: only pushing the object that contains id and value
                    acc[name]['variants'].push({name, productId, variantId, variant, sku, price, currency, image});

                    return acc;
                }, {})
            ).map(([name, options]) => ({name, options}));
        },
        setAllProductsLoading(state, value) {
            state.allProductsLoading = value;
        },
        setThemeJson(state, theme) {
            state.themeJson = theme;
        }
    },

    actions: {

        setSelectedProducts({commit}, value) {
            commit('setSelectedProducts', value)
        },
        setShop({commit}, value) {
            commit('setShop', value)
        },
        setToken({commit}, value) {
            commit('setToken', value)
        },
        setOrderNumber({commit}, value) {
            commit('setOrderNumber', value)
        },
        setEmail({commit}, value) {
            commit('setEmail', value)
        },
        setIban({commit}, value) {
            commit('setIban', value)
        },
        setFullName({commit}, value) {
            commit('setFullName', value)
        },
        setPhoneNumber({commit}, value) {
            commit('setPhoneNumber', value)
        },
        setAddress1({commit}, value) {
            commit('setAddress1', value)
        },
        setAddress2({commit}, value) {
            commit('setAddress2', value)
        },
        setCity({commit}, value) {
            commit('setCity', value)
        },
        setCounty({commit}, value) {
            commit('setCounty', value)
        },
        setZipCode({commit}, value) {
            commit('setZipCode', value)
        },
        setCountry({commit}, value) {
            commit('setCountry', value)
        },
        setBankAccountHolder({commit}, value) {
            commit('setBankAccountHolder', value)
        },
        setReturnType({commit}, value) {
            commit('setReturnType', value)
        },
        setDescription({commit}, value) {
            commit('setDescription', value)
        },
        setReturnProducts({commit}, value) {
            commit('setReturnProducts', value)
        },
        setAllProducts({commit}, value) {
            commit('setAllProducts', value)
        },
        send_products_back({commit, state}) {
            return new Promise((resolve, reject) => {
                let url = process.env.VUE_APP_SUBMIT_RETURN_URL;
                var parameters = {
                    "iban": state.iban,
                    "fullName":state.fullName,
                    "phoneNumber":state.phoneNumber,
                    "address1":state.address1,
                    "address2":state.address2,
                    "city":state.city,
                    "county":state.county,
                    "zipCode":state.zipCode,
                    "country":state.country,
                    'bankAccountHolder': state.bankAccountHolder,
                    'returnType': state.returnType,
                    'description': state.description,
                    'returnProducts': state.returnProducts,
                    'allProducts': state.allProducts
                };

                axios.post(url, parameters, {
                    params: buildOrderLookupParams({
                        shop: state.shop,
                        token: state.token,
                        orderName: state.order_number,
                        emailAddress: state.email_address,
                        phoneNumber: state.phoneNumber
                    })
                })
                    .then(response => {
                        commit('setAll', response.data)
                        resolve();
                    })
                    .catch(function (error) {
                        reject(error);
                    })
            })
        },
        getOrder({commit, state}) {
            return new Promise((resolve, reject) => {
                let url = process.env.VUE_APP_SEARCH_URL;

                axios.get(url, {
                    params: buildOrderLookupParams({
                        shop: state.shop,
                        token: state.token,
                        orderName: state.order_number,
                        emailAddress: state.email_address,
                        phoneNumber: state.phoneNumber
                    })
                })

                    .then(response => {
                        response.data.products.forEach(function (product, index) {
                            if (typeof product.index === 'undefined')
                                product.index = index
                        })
                        commit('setAll', response.data)
                        resolve();
                    })
                    .catch(function (error) {
                        reject(error);
                    })
            })
        },
        getShopPreferences({commit,state}) {
            return new Promise((resolve,reject) => {
                const preferences={
                    fields:{
                        fullName:{
                            enabled:true,
                            required:false
                        },
                        phoneNumber:{
                            enabled:true,
                            required:false
                        },
                        iban:{
                            enabled:true,
                            required:false
                        },
                        bankAccountHolder:{
                            enabled:true,
                            required:false
                        },
                        address1:{
                            enabled:true,
                            required:false
                        },
                        address2:{
                            enabled:true,
                            required:false
                        },
                        city:{
                            enabled:true,
                            required:false
                        },
                        county:{
                            enabled:true,
                            required:false
                        },
                        zipCode:{
                            enabled:true,
                            required:false
                        },
                        country:{
                            enabled:true,
                            required:false
                        },
                        returnType:{
                            enabled:true,
                            required:false
                        },
                        description:{
                            enabled:true,
                            required:false
                        },
                    },
                    lang:"ro",
                    termsLink:"https://google.ro",
                    editQuantity: false,
                    replaceProduct: false
                }
                var url = `${process.env.VUE_APP_BASE_URL}/preferences?shop=${state.shop}&token=${state.token}`;
                axios.get(url)
                .then(response => {
                    commit('setShopPreferences', {...preferences,...response.data});
                    commit('setExtensionVisible', true);
                    resolve();
                })
                .catch(function (error) {
                    const status = error && error.response ? error.response.status : null;
                    if (status === 402) {
                        commit('setExtensionVisible', false);
                        resolve();
                        return;
                    }
                    commit('setShopPreferences', preferences)
                    reject(error);
                })
            })
        },

        getAllProducts({commit, state}) {
            return new Promise((resolve, reject) => {
                var url = `${process.env.VUE_APP_SEARCH_PRODUCTS_URL}?shop=${state.shop}&token=${state.token}&query`;

                axios.get(url).then(response => {
                    commit('setAllProducts', response.data);
                    resolve();
                }).catch(function (error) {
                    reject(error);
                })
            })
        },

        searchProducts({commit, state}, word) {
            commit('setAllProductsLoading', true);

            return new Promise((resolve, reject) => {
                var url = process.env.VUE_APP_SEARCH_PRODUCTS_URL;

                axios.get(url, {
                    params: {
                        shop: state.shop,
                        token: state.token,
                        query: word
                    }
                }).then(response => {
                    commit('setAllProductsLoading', false);
                    commit('setAllProducts', response.data);
                    resolve();
                }).catch(function (error) {
                    commit('setAllProductsLoading', false);
                    reject(error);
                })
            })
        },

        loadThemeFromPreferences({ commit }, preferences) {
            if (preferences.themeJson) {
                commit('setThemeJson', preferences.themeJson);
            }
        }
    },
    plugins: []
})
